export const hourlyCalendar = {
  title: "Calendrier à l'heure",
  navSubtitle: "Location à l'heure de votre hôtel",
  hotel: "Hôtel",
  rooms: "Chambres",
  roomsAbbr: "ch.",
  noDisp: "Indisp.",
  footer: {
    free: "{n} libres",
    occupied: "{n} occupées",
    cleaning: "{n} en ménage",
    timezone: "Fuseau horaire : {tz}",
  },
  today: "Aujourd'hui",
  prevDay: "Jour précédent",
  nextDay: "Jour suivant",
  newStay: "Nouveau séjour",
  settingsBtn: "Réglages de la location à l'heure",
  retry: "Réessayer",
  dragHint: "Faites glisser sur une chambre pour créer un séjour",
  groupFree: "{free} sur {total} libres",
  zoom: { label: "Zoom", compact: "Compact", normal: "Normal", wide: "Large" },
  duration: { min: "{n} min", h: "{n} h", hmin: "{h} h {m} min" },
  kpi: {
    free: "Libres maintenant",
    occupied: "Occupées",
    cleaning: "En ménage",
    arrivals: "Arrivent dans 1 h",
    overdueAlert: "1 chambre a dépassé son heure | {n} chambres ont dépassé leur heure",
  },
  state: {
    free: "Libre",
    freeNext: "Libre · prochain {time}",
    soon: "Arrive à {time}",
    occupied: "Occupée",
    occupiedLeft: "Occupée · reste {time}",
    overdue: "Dépassé de {time}",
    due: "En attente d'arrivée",
    cleaning: "Ménage · {time}",
    closed: "Fermée",
    maintenance: "Hors service",
  },
  status: {
    booked: "Réservé",
    in_house: "En cours",
    checked_out: "Terminé",
    cancelled: "Annulé",
    no_show: "Non présenté",
  },
  block: {
    noName: "Sans nom",
    blocked: "Bloquée",
    night: "Nuit",
    closed: "Fermée",
    maintenance: "Hors service",
    left: "Reste {time}",
  },
  legend: {
    booked: "Réservé",
    inHouse: "En cours",
    overdue: "Heure dépassée",
    cleaning: "Ménage",
    night: "Réservation à la nuit",
    closed: "Fermée",
  },
  rangeMenu: {
    create: "Créer un séjour",
    createSub: "Sur le créneau sélectionné",
    block: "Bloquer ce créneau",
    blockSub: "La chambre ne se vend pas sur ce créneau",
    closeDay: "Fermer la chambre toute la journée",
    closeDaySub: "Ce jour-là, cette chambre ne se vend pas",
  },
  blockMenu: {
    editReason: "Changer le motif",
    editReasonSub: "Il apparaît sur le calendrier",
    remove: "Retirer le blocage",
    removeSub: "La chambre est de nouveau en vente",
  },
  blockModal: {
    titleRange: "Bloquer ce créneau",
    titleDay: "Fermer la chambre",
    titleEdit: "Motif du blocage",
    msgRange: "{room} ne sera pas vendue de {range}.",
    msgDay: "{room} ne sera pas vendue le {date}.",
    msgDayRest: "{room} ne sera plus vendue le reste de la journée (à partir de {time}).",
    msgEdit: "{room}",
    reasonLabel: "Motif",
    reasonHint: "(visible sur le calendrier)",
    placeholder: "Maintenance, usage personnel…",
    cancel: "Annuler",
    block: "Bloquer",
    save: "Enregistrer",
    presetMaintenance: "Maintenance",
    presetOwner: "Usage du propriétaire",
    presetRepair: "Travaux",
    presetDeepClean: "Grand ménage",
    presetClosed: "Fermée",
  },
  drawer: {
    close: "Fermer",
    closeBtn: "Fermer",
    newTitle: "Nouveau séjour",
    newPill: "Nouveau",
    when: "Quand",
    room: "Chambre",
    start: "Arrivée",
    end: "Départ",
    nextDay: "lendemain",
    duration: "Durée",
    other: "Autre",
    free: "Chambre libre sur ce créneau",
    freeWithCleaning: "Libre · {n} min sont gardées pour le ménage au départ",
    freeWillClose: "Libre · ensuite elle reste fermée jusqu'à {hour}",
    busy: "Occupée de {from} à {to}",
    busyClosed: "Fermée de {from} à {to}",
    busyMaintenance: "Chambre hors service",
    guest: "Client",
    guestName: "Nom",
    phone: "Téléphone",
    optional: "Facultatif",
    guests: "Personnes",
    charge: "Paiement",
    price: "Prix",
    method: "Moyen de paiement",
    methods: { cash: "Espèces", card: "Carte", transfer: "Virement", other: "Autre" },
    paid: "Encaissé",
    paidHint: "Vous avez déjà l'argent de ce séjour.",
    notes: "Notes",
    notesPh: "Plaque d'immatriculation, demandes, tout ce qui est utile",
    guestTitle: "Enregistrement du client",
    sendCheckin: "Envoyer le lien de check-in",
    sendCheckinHint: "Il part à l'enregistrement, sur le téléphone du client.",
    sendCheckinNoPhone: "Saisissez le téléphone du client pour pouvoir lui envoyer le check-in.",
    doCheckin: "Faire le check-in",
    edit: "Modifier",
    client: "Client",
    paidYes: "Encaissé",
    paidNo: "Non encaissé",
    markPaid: "Marquer comme encaissé",
    doCheckinHint: "Ouvrez-le sur le téléphone du client ou transmettez le lien : nom, prénom et document, avec scan s'il le souhaite.",
    copyLink: "Copier le lien",
    copied: "Lien copié",
    checkinDone: "Check-in fait · {n} client enregistré | Check-in fait · {n} clients enregistrés",
    checkinErrors: {
      no_reservation: "Activez «Enregistrer les séjours comme réservations» dans les réglages pour pouvoir demander le check-in.",
      no_phone: "Saisissez le téléphone du client pour pouvoir le lui envoyer.",
      send_failed: "L'envoi a échoué. Essayez de copier le lien et de le transmettre vous-même.",
      not_requested: "L'envoi a échoué. Essayez de copier le lien et de le transmettre vous-même.",
    },
    checkinSent: "Check-in envoyé",
    sendCheckinFailed: "Le check-in n'a pas pu être envoyé. Vérifiez le téléphone du client.",
    save: "Enregistrer",
    saveAndIn: "Enregistrer et faire entrer",
    saveChanges: "Enregistrer les modifications",
    checkIn: "Enregistrer l'arrivée",
    checkOut: "Enregistrer le départ",
    extend30: "30 min",
    extend60: "1 h",
    extendOther: "Autre",
    extendHow: "Prolonger",
    extendApply: "Prolonger",
    cancelBtn: "Annuler",
    checkOutNotYet: "Le départ pourra être enregistré une fois le séjour commencé",
    confirmEarlyOutTitle: "Le séjour n a pas encore commencé",
    confirmEarlyOut: "Ce séjour commence plus tard. Enregistrer le départ maintenant le clôture et libère la chambre. Si le client n est pas venu, utilisez « Non présenté ».",
    noShow: "Non présenté",
    cancelStay: "Annuler le séjour",
    keep: "Retour",
    confirmCancel: "Il est annulé et la chambre est libre sur ce créneau. C'est définitif.",
    confirmNoShow: "Le créneau redevient disponible. Il est noté que le client n'est pas venu.",
    confirmNoShowInHouse: "Il figurait comme arrivé mais n'est jamais monté : l'arrivée est annulée et le créneau redevient libre.",
    confirmCancelInHouse: "Il figurait comme arrivé : l'arrivée est annulée, le séjour aussi, et la chambre est libre. C'est définitif.",
    confirmNoShowTitle: "Le client ne s'est pas présenté ?",
    confirmCancelTitle: "Annuler ce séjour ?",
    remaining: "Reste {time}",
    overdue: "Dépassé de {time}",
    startsIn: "Commence dans {time}",
    waiting: "Son créneau a commencé : en attente d'arrivée",
    closedInfo: "Séjour clôturé : seuls le paiement et les notes peuvent être modifiés.",
    night: {
      title: "Réservation à la nuit",
      dates: "Du {from} au {to}",
      code: "Code",
      channel: "Canal",
      hint: "Les réservations à la nuit se gèrent depuis le calendrier de l'hôtel. Elles apparaissent ici pour qu'aucun séjour à l'heure ne les chevauche.",
      open: "Aller au calendrier de l'hôtel",
    },
  },
  settings: {
    title: "Location à l'heure",
    enable: "Louer à l'heure",
    subtitle: "Comment cet hôtel loue à l'heure",
    offTitle: "Si vous la désactivez",
    offBody: "Le calendrier à l'heure n'est plus disponible et l'hôtel fonctionne comme avant. Rien n'est supprimé.",
    offBodyStays: "Vous avez {n} séjours à l'heure à venir : ils ne sont pas supprimés, mais vous ne les verrez plus jusqu'à la réactivation.",
    enabledOn: "Activée : le calendrier à l'heure est utilisé",
    enabledOff: "Désactivée",
    requirements: "Conditions",
    req: {
      rooms: "Chambres créées ({n})",
      channels: "Aucun canal de vente connecté",
      ical: "Aucun calendrier iCal synchronisé",
      web: "Réservation en ligne désactivée",
      nights: "{n} réservations à la nuit à venir : elles apparaîtront dans le calendrier et bloqueront leurs chambres",
    },
    reqWhy: "Les canaux, l'iCal et le site vendent des nuits et ignorent les heures : avec l'un d'eux actif, la même chambre pourrait être vendue deux fois.",
    cleaning: "Ménage entre les séjours",
    cleaningHint: "Réservé automatiquement après chaque départ.",
    pending: "En attente de ménage",
    pendingHint: "Quand un client part, la chambre est marquée « à nettoyer » dans Ménage et dans l'app pendant ce temps. Cela NE bloque PAS la vente : si quelqu'un arrive avant, vous la nettoyez à ce moment-là.",
    none: "aucun",
    minutes: "min",
    hours: "h",
    closeTitle: "Fermer jusqu'à l'heure d'ouverture",
    closeHint: "Pour quand on ne nettoie pas tout de suite : la chambre reste fermée et personne ne peut la vendre avant l'ouverture.",
    closeAfterStay: "À la fin d'un séjour, laisser la chambre fermée",
    closeAfterStayHint: "Elle se ferme seule jusqu'à l'heure d'ouverture du lendemain. Si vous la nettoyez avant, appuyez sur « Elle est propre » et elle repart à la vente.",
    afterTitle: "Après chaque séjour",
    afterHint: "Combien de temps la chambre cesse d'être vendue quand un client part.",
    untilOpening: "Jusqu'à l'ouverture",
    reopenHour: "Heure d'ouverture de la vente",
    reopenNote: "Les chambres sales repartent à la vente à {hour}.",
    markClean: "Elle est propre",
    markCleanHint: "Ouvre la chambre maintenant, sans attendre l'heure d'ouverture.",
    closeThisStay: "Laisser la chambre fermée à la fin",
    closeThisStayHint: "Invendable jusqu'à {hour}. L'heure se change dans les réglages.",
    dayStart: "Début de la journée du calendrier",
    dayRange: "de {from} à {from} le lendemain",
    dayStartHint: "Choisissez l'heure la plus calme : la nuit s'affiche d'un seul tenant.",
    quickHours: "Durées rapides",
    quickHoursHint: "Proposées comme raccourcis à la création d'un séjour (jusqu'à 6).",
    guestTitle: "Enregistrement du client",
    asReservation: "Enregistrer les séjours comme réservations",
    asReservationHint: "Chaque séjour crée sa réservation : c'est ainsi que l'argent apparaît dans vos rapports et que vous pouvez demander le check-in et la déclaration des voyageurs. Désactivé, les ventes à l'heure ne comptent pas dans vos revenus.",
    checkinDefault: "Demander le check-in par défaut",
    checkinDefaultHint: "L'interrupteur de la fiche du séjour sera activé.",
    guestHint: "Ces réservations ne reçoivent pas les messages prévus pour les nuits (bienvenue, arrivée, départ ni avis) : le lien de check-in part quand vous le demandez.",
    save: "Enregistrer les réglages",
    saved: "Réglages enregistrés",
  },
  empty: {
    eyebrow: "Location à l'heure",
    title: "Louez vos chambres à l'heure",
    body: "Un calendrier conçu pour les motels et les hôtels de courts séjours : chaque chambre à la minute près, des séjours créés en faisant glisser, et le ménage entre deux séjours réservé automatiquement.",
    point1: "État de chaque chambre en temps réel",
    point2: "Glissez pour créer, déplacer ou prolonger",
    point3: "Ménage entre les séjours, automatique",
    cta: "Activer la location à l'heure",
    ctaBlocked: "Remplissez les conditions pour l'activer",
    noHotelsTitle: "Vous n'avez pas encore d'hôtel",
    noHotels: "La location à l'heure fonctionne avec les hébergements de type hôtel qui ont des chambres créées.",
  },
  guide: {
    open: "Mode d'emploi",
    title: "Comment fonctionne le calendrier horaire",
    subtitle: "L'essentiel en une minute : créer des séjours, enregistrer les arrivées et les départs, et fermer les chambres que vous ne vendez pas.",
    createTitle: "Créer un séjour",
    createBody: "Faites glisser sur la ligne de la chambre, de l'heure d'arrivée à l'heure de départ. Vous pouvez aussi cliquer sur «Nouveau séjour» et saisir les heures.",
    moveTitle: "Déplacer et prolonger",
    moveBody: "Faites glisser la barre pour changer d'heure ou de chambre. Tirez le bord droit pour allonger ou raccourcir le séjour. Si le créneau est pris, le calendrier refuse de le déposer.",
    checkinTitle: "Arrivée et départ",
    checkinBody: "Ouvrez le séjour et enregistrez l'arrivée quand le client arrive, et le départ quand il s'en va. S'il dépasse l'heure, la barre passe au rouge avec les minutes en trop.",
    cleaningTitle: "Ménage entre deux séjours",
    cleaningBody: "Après chaque départ, le créneau de ménage que vous avez réglé se réserve tout seul. Personne ne peut arriver pendant ce temps.",
    blockTitle: "Bloquer un créneau ou fermer la chambre",
    blockBody: "Sélectionnez une plage et choisissez «Bloquer ce créneau», ou «Fermer la chambre toute la journée» si vous ne la vendez pas ce jour-là. Cliquez sur le blocage pour changer le motif ou le retirer.",
    settingsTitle: "Réglages",
    settingsBody: "L'engrenage permet de régler le temps de ménage, l'heure à laquelle commence la journée du calendrier et les durées rapides proposées à la création d'un séjour.",
    colorsTitle: "Ce que signifie chaque couleur",
    colors: {
      booked: "Créé, le client n'est pas encore arrivé",
      inHouse: "Le client est dans la chambre",
      overdue: "L'heure de départ est dépassée",
      cleaning: "Créneau réservé au ménage",
      night: "Vient du calendrier par nuits",
      closed: "Bloquée ou fermée à la main",
    },
    otasTitle: "Réservations par nuits et canaux",
    otasBody: "Les réservations par nuits apparaissent ici pour que vous sachiez quelles chambres sont occupées, mais elles se gèrent dans le calendrier de l'hôtel. Tant que vous vendez à l'heure, cet hébergement ne se connecte pas aux OTA.",
    gotIt: "Compris",
  },
  toasts: {
    created: "Séjour créé",
    checkedIn: "Arrivée enregistrée",
    checkedOut: "Départ enregistré · ménage en cours",
    updated: "Modifications enregistrées",
    extended: "Séjour prolongé",
    cancelled: "Séjour annulé",
    noShow: "Marqué comme non présenté",
    moved: "Séjour déplacé",
    resized: "Durée mise à jour",
    activated: "Location à l'heure activée",
    blocked: "Créneau bloqué",
    blockUpdated: "Motif mis à jour",
    blockRemoved: "Blocage retiré",
    loadError: "Impossible de charger le calendrier à l'heure",
    error: "Enregistrement impossible. Réessayez.",
  },
  errors: {
    room_busy: "La chambre est occupée de {from} à {to}",
    hourly_disabled: "La location à l'heure n'est pas activée pour cet hôtel.",
    room_maintenance: "Cette chambre est hors service.",
    room_not_found: "Cette chambre n'appartient pas à cet hôtel.",
    invalid_duration: "La durée doit être comprise entre 30 minutes et 48 heures.",
    invalid_start: "L'heure d'arrivée n'est pas valide.",
    stay_closed: "Ce séjour est déjà clôturé : il ne peut pas être déplacé.",
    invalid_status: "Cette action n'est pas possible dans l'état actuel du séjour.",
    requirements_not_met: "Cet hôtel ne remplit pas encore les conditions pour louer à l'heure.",
    not_found: "Élément introuvable. Rechargez la page.",
    generic: "Une erreur s'est produite. Réessayez.",
  },
};
